export const MODE_CREATE = "create";
export const MODE_EDIT = "edit";
export const TYPE_EMAIL = "1";
export const TYPE_SLACK = "2";
